import React from 'react';
import { observer } from 'mobx-react';

import AppUser from 'js/stores/AppUser';
import Icon from 'js/components/common/Icon';
import Container from './Container';
import Message from './Message';

export default observer(() => (
  <Container>
    <Icon name="refresh" spin />
    <Message>Welcome back {AppUser.first_name} ...</Message>
  </Container>
));
